import React from "react";
import * as animationData from "./Success_Lottie.json";
import "./Success_Lottie.css";
import Lottie from "react-lottie";

export const Success_Lottie = () => {
  const defaultOptions = {
    loop: true,
    animationData: animationData,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };
  return (
    <section className="main">

        <div className="lottie_text_div">
            <p className="lottie_text">Your Ride Booked Successfully!</p>
        </div>
      <div className="success_div">
        <Lottie className="me-auto" options={defaultOptions} />
      </div>
    </section>
  );
};
